import React, { useMemo, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import PathwayStagesTable from '@components/PathwayStagesTable';
import PathwayDetailsCard from '@pathways/cards/Pathways/PathwayDetails/Card';
import IndexEventTriggeredRulesCard from '@pathways/cards/Pathways/IndexEventTriggeredRules/Card';
import CareTeamPermissionsCard from '@pathways/cards/Pathways/CareTeamPermissions/Card';
import { Card, ColumnGroup, Column } from '@cards/Card';
import useWizard from '@components/Wizard/useWizard';
import { useDispatch } from 'react-redux';
import { fetchDocuments } from '@redux/documents/actions';
import { fetchForms } from '@redux/forms/actions';
import { fetchContentMessages } from '@redux/contentMessages/actions';
import createColumns from './createColumns';
import createDataSource from './createDataSource';

function Review() {
  const { formData } = useWizard();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchDocuments());
    dispatch(fetchForms());
    dispatch(fetchContentMessages());
  }, [dispatch]);

  const roleRulesMap = useMemo(() => {
    return formData.careTeamPermissions.careTeamPermissions?.reduce((acc, role) => {
      role.permissions.forEach(permission => {
        const ruleId = permission.id || permission.rule?.id;
        if (!ruleId) {
          return;
        }

        if (!acc[ruleId]) {
          acc[ruleId] = [];
        }

        acc[ruleId].push({
          roleName: role.name,
          permissionType: permission.permissionType,
        });
      });
      return acc;
    }, {});
  }, [formData.careTeamPermissions]);

  const [columns, dataSource] = useMemo(
    () => [
      createColumns(formData.stagedRules.stages, roleRulesMap, t),
      createDataSource(formData.stagedRules.stages),
    ],
    [formData, t, roleRulesMap],
  );

  const pathwayData = useMemo(
    () => ({
      ...formData.details,
      ...formData.stagedRules,
      ...formData.indexEvents,
      ...formData.indexEventRules,
      ...formData.careTeamPermissions,
    }),
    [formData],
  );

  return (
    <>
      <ColumnGroup>
        <Column>
          <Card
            className="pathway-stages-table-card"
            title={t('pathways:ProcedurePathways.wizard.stages.stepName')}
          >
            <PathwayStagesTable columns={columns} dataSource={dataSource} />
          </Card>
        </Column>
      </ColumnGroup>
      <ColumnGroup>
        <Column>
          <IndexEventTriggeredRulesCard pathway={pathwayData} roleRulesMap={roleRulesMap} />
        </Column>
      </ColumnGroup>
      <ColumnGroup>
        <Column>
          <CareTeamPermissionsCard pathway={pathwayData} />
        </Column>
      </ColumnGroup>
      <ColumnGroup>
        <Column>
          <PathwayDetailsCard pathway={pathwayData} />
        </Column>
        <Column></Column>
      </ColumnGroup>
    </>
  );
}

export default Review;
